import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

const EMPTY = { name: "", address: "", phone: "", email: "", website: "", rating: "", reviews_count: "", hours: "",
  maps_url: "", description: "" };
const FIELDS = [["name", "Nome *"], ["address", "Morada"], ["phone", "Telefone / WhatsApp"], ["email", "Email"],
  ["website", "Website ou rede social"], ["rating", "Nota Google (0–5)"], ["reviews_count", "Nº de avaliações"], ["maps_url", "Link Google Maps"]];

export function AddBusinessDialog({ cid, open, onClose, onAdded }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    setBusy(true);
    try {
      await api.post(`/prospect/campaigns/${cid}/businesses`, {
        ...f, email: f.email || null, rating: f.rating ? Number(f.rating) : null,
        reviews_count: f.reviews_count ? Number(f.reviews_count) : null,
      });
      setF(EMPTY);
      onAdded();
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-2xl" data-testid="add-business-dialog">
        <DialogHeader>
          <DialogTitle>Adicionar negócio à mão</DialogTitle>
          <DialogDescription>Só dados reais dados pelo próprio negócio. Fotos e avaliações vêm apenas do Google Places (pesquisa) ou de fotos enviadas pelo restaurante (na ficha do negócio). Nunca copie conteúdo de outros sites.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 sm:grid-cols-2">
          {FIELDS.map(([k, l]) => (
            <div key={k} className="space-y-1"><Label>{l}</Label><Input value={f[k]} onChange={set(k)} data-testid={`biz-${k}`} /></div>
          ))}
          <div className="space-y-1 sm:col-span-2"><Label>Horário</Label><Textarea rows={2} value={f.hours} onChange={set("hours")} data-testid="biz-hours" /></div>
          <div className="space-y-1 sm:col-span-2"><Label>Descrição / serviços / menu (texto real)</Label><Textarea rows={3} value={f.description} onChange={set("description")} data-testid="biz-description" /></div>
        </div>
        <DialogFooter><Button className="rounded-full" disabled={busy || f.name.length < 2} onClick={save} data-testid="biz-save-btn">Adicionar</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
